import React from 'react';
import { BlogContainer, BlogHeadingText } from './BlogStyles';

const Blog = () => {
    return (
        <div>
            <BlogContainer>
                <BlogHeadingText>
                    Coming soon...
                </BlogHeadingText>
            </BlogContainer>
        </div>
    );
};

export default Blog;